import {
  Button,
  Popover,
  Slider,
  Row,
  Col,
  InputNumber,
  Form,
  Switch,
} from "antd";
import React, { useState, useEffect } from "react";
import ColorPicker from "./topbar-design/ColorPicker";
import { MdOutlineOpacity } from "react-icons/md";
import { BsBorderWidth, BsBorderOuter } from "react-icons/bs";

const TopBarDesign = ({
  selectLayer,
  backgroundDesign,
  imageLayers,
  onChange,
  ratio,
  onApplyAll,
  backgrounds,
  showCenterLinesStatutBtn,
  setShowCenterLinesStatutBtn,
}) => {
  const [shadowColor, setShadowColor] = useState("#000000");
  const [shadowOpacity, setShadowOpacity] = useState(0);
  const [shadowBlur, setShadowBlur] = useState(0);
  const [shadowOffsetX, setShadowOffsetX] = useState(0);
  const [shadowOffsetY, setShadowOffsetY] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [stroke, setStroke] = useState("#000000");
  const [strokeWidth, setStrokeWidth] = useState(0);

  useEffect(() => {
    const findLayer = imageLayers.find((i) => i.id == selectLayer);
    if (findLayer) {
      setShadowColor(findLayer.shadowColor);
      setShadowOpacity(findLayer.shadowOpacity);
      setShadowBlur(findLayer.shadowBlur);
      setShadowOffsetX(findLayer.shadowOffsetX);
      setShadowOffsetY(findLayer.shadowOffsetY);
      setOpacity(findLayer.opacity);
      setStroke(findLayer.stroke);
      setStrokeWidth(findLayer.strokeWidth);
    }
  }, [imageLayers]);

  useEffect(() => {
    if (selectLayer) {
      const newimageLayers = imageLayers.map((i) => {
        if (i.id == selectLayer) {
          i = {
            ...i,
            shadowColor,
            shadowOpacity,
            shadowBlur,
            shadowOffsetX,
            shadowOffsetY,
            opacity,
            stroke,
            strokeWidth: strokeWidth,
          };
        }
        return i;
      });
      onChange(newimageLayers);
    }
  }, [
    shadowColor,
    shadowOpacity,
    shadowBlur,
    shadowOffsetX,
    shadowOffsetY,
    opacity,
    stroke,
    strokeWidth,
  ]);
  return (
    <div className="bar-top-autobaner">
      <div className="bar-top-control-autobaner">
        <div
          style={{
            opacity: selectLayer ? "1" : 0.5,
            pointerEvents: selectLayer ? "all" : "none",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          {/* opacity */}
          <Popover
            placement="bottomLeft"
            trigger="click"
            className="popover-topbar-autobanner"
            content={
              <div className="body-popover-topbar-autobanner">
                <Row>
                  <Col span={18}>
                    <Slider
                      min={0}
                      max={1}
                      step={0.1}
                      onChange={setOpacity}
                      value={typeof opacity === "number" ? opacity : 0}
                    />
                  </Col>
                  <Col
                    span={6}
                    style={{
                      paddingLeft: 10,
                    }}
                  >
                    <InputNumber
                      min={0}
                      max={1}
                      step={0.1}
                      value={opacity}
                      onChange={setOpacity}
                      style={{
                        width: "100%",
                      }}
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <button className="transparency_autobanner__btn">
              <MdOutlineOpacity />
            </button>
          </Popover>

          {/* Border */}
          <Popover
            placement="bottomLeft"
            trigger="click"
            className="popover-topbar-autobanner"
            content={
              <div className="body-popover-topbar-autobanner">
                <Form layout="horizontal">
                  <Form.Item label="Color">
                    <ColorPicker value={stroke} onChange={setStroke} />
                  </Form.Item>
                  <Form.Item label="Width">
                    <Row>
                      <Col span={18}>
                        <Slider
                          min={0}
                          max={30}
                          step={1}
                          onChange={setStrokeWidth}
                          value={
                            typeof strokeWidth === "number" ? strokeWidth : 0
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <InputNumber
                          min={0}
                          max={30}
                          step={1}
                          value={strokeWidth}
                          onChange={setStrokeWidth}
                          style={{
                            width: "100%",
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </div>
            }
          >
            <button className="transparency_autobanner__btn">
              <BsBorderWidth />
            </button>
          </Popover>

          {/* Shadow */}
          <Popover
            placement="bottomLeft"
            trigger="click"
            className="popover-topbar-autobanner"
            content={
              <div className="body-popover-topbar-autobanner">
                <Form layout="horizontal">
                  <Form.Item label="Color">
                    <ColorPicker
                      value={shadowColor}
                      onChange={setShadowColor}
                    />
                  </Form.Item>
                  <Form.Item label="Opacity">
                    <Row>
                      <Col span={18}>
                        <Slider
                          min={0}
                          max={1}
                          step={0.1}
                          onChange={setShadowOpacity}
                          value={
                            typeof shadowOpacity === "number"
                              ? shadowOpacity
                              : 0
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <InputNumber
                          min={0}
                          max={1}
                          step={0.1}
                          value={shadowOpacity}
                          onChange={setShadowOpacity}
                          style={{
                            width: "100%",
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label="Blur">
                    <Row>
                      <Col span={18}>
                        <Slider
                          min={0}
                          max={100}
                          step={1}
                          onChange={setShadowBlur}
                          value={
                            typeof shadowBlur === "number" ? shadowBlur : 0
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <InputNumber
                          min={0}
                          max={255}
                          step={1}
                          value={shadowBlur}
                          onChange={setShadowBlur}
                          style={{
                            width: "100%",
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label="OffsetX">
                    <Row>
                      <Col span={18}>
                        <Slider
                          min={-50}
                          max={50}
                          step={1}
                          onChange={setShadowOffsetX}
                          value={
                            typeof shadowOffsetX === "number"
                              ? shadowOffsetX
                              : 0
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <InputNumber
                          min={-50}
                          max={50}
                          step={1}
                          value={shadowOffsetX}
                          onChange={setShadowOffsetX}
                          style={{
                            width: "100%",
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label="OffsetY">
                    <Row>
                      <Col span={18}>
                        <Slider
                          min={-50}
                          max={50}
                          step={1}
                          onChange={setShadowOffsetY}
                          value={
                            typeof shadowOffsetY === "number"
                              ? shadowOffsetY
                              : 0
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <InputNumber
                          min={-50}
                          max={50}
                          step={1}
                          value={shadowOffsetY}
                          onChange={setShadowOffsetY}
                          style={{
                            width: "100%",
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </div>
            }
          >
            <Button className="bar-top-control-autobaner__btn">Shadow</Button>
          </Popover>
        </div>
        <div className="item-control-autobanner">
          <button
            onClick={() => setShowCenterLinesStatutBtn((prev) => !prev)}
            className={`line-status_autobanner__btn ${
              showCenterLinesStatutBtn && "active"
            }`}
          >
            <BsBorderOuter />
          </button>
        </div>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
          }}
        >
          <Button
            type="ghost"
            className="btn-apply-all-autobanner"
            disabled={backgrounds.length <= 0}
            onClick={onApplyAll}
          >
            Apply all
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopBarDesign;
